/**
 * AJAX 요청 유틸리티
 */

/**
 * 제휴 문의 제출
 * @param {FormData|Object} formData - 폼 데이터
 * @returns {Promise<Object>} 응답 데이터
 */
export async function submitPartnershipInquiry(formData) {
  try {
    const url = "/module/request.partner.php";

    // FormData가 아닌 경우 FormData로 변환
    let data;
    if (formData instanceof FormData) {
      data = formData;
    } else {
      data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
    }

    const response = await fetch(url, {
      method: "POST",
      body: data,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.success) {
      return {
        success: true,
        message: result.message || "문의가 정상적으로 접수되었습니다.",
      };
    } else {
      return {
        success: false,
        message: result.message || "문의 접수 중 오류가 발생했습니다.",
      };
    }
  } catch (error) {
    console.error("Partnership inquiry error:", error);
    return { success: false, message: "네트워크 오류입니다." };
  }
}

/**
 * 온라인 예약 문의 제출
 * @param {FormData|Object} formData - 폼 데이터
 * @returns {Promise<Object>} 응답 데이터
 */
export async function submitBookingInquiry(formData) {
  try {
    const url = "/module/request.booking.php";

    // FormData가 아닌 경우 FormData로 변환
    let data;
    if (formData instanceof FormData) {
      data = formData;
    } else {
      data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
    }

    const response = await fetch(url, {
      method: "POST",
      body: data,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.success) {
      return {
        success: true,
        message: result.message || "예약이 정상적으로 접수되었습니다.",
      };
    } else {
      return {
        success: false,
        message: result.message || "예약 접수 중 오류가 발생했습니다.",
      };
    }
  } catch (error) {
    console.error("Booking inquiry error:", error);
    return { success: false, message: "네트워크 오류입니다." };
  }
}

/**
 * 간편 문의 제출
 * @param {FormData|Object} formData - 폼 데이터
 * @returns {Promise<Object>} 응답 데이터
 */
export async function submitSimpleInquiry(formData) {
  try {
    const url = "/module/request.simple.php";

    // FormData가 아닌 경우 FormData로 변환
    let data;
    if (formData instanceof FormData) {
      data = formData;
    } else {
      data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
    }

    const response = await fetch(url, {
      method: "POST",
      body: data,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.success) {
      return {
        success: true,
        message: result.message || "문의가 정상적으로 접수되었습니다.",
      };
    } else {
      return {
        success: false,
        message: result.message || "문의 접수 중 오류가 발생했습니다.",
      };
    }
  } catch (error) {
    console.error("Simple inquiry error:", error);
    return { success: false, message: "네트워크 오류입니다." };
  }
}
